import React, { useState } from "react";
import LogoTim from "../../Assets/TimLogo.png";
import { useLogin } from "./useLogin";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import "./Login.css";

/* ------------------------------------------------------------------ */
/* Ikon (SVG inline)                                                   */
/* ------------------------------------------------------------------ */

const IconProps = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

const UserIcon = () => (
  <svg {...IconProps}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const LockIcon = () => (
  <svg {...IconProps}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const EyeIcon = () => (
  <svg {...IconProps}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg {...IconProps}>
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

/* ------------------------------------------------------------------ */
/* Komponen kecil                                                      */
/* ------------------------------------------------------------------ */

// Input password dengan tombol mata (tampil / sembunyikan)
const PasswordInput = ({ withIcon = false, onEnter, ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={
        withIcon ? "lg_input_wrap" : "lg_input_wrap lg_input_wrap_plain"
      }
    >
      {withIcon && (
        <span className="lg_input_icon">
          <LockIcon />
        </span>
      )}
      <input
        className={
          withIcon ? "lg_input" : "lg_input lg_input_plain lg_input_has_eye"
        }
        type={visible ? "text" : "password"}
        onKeyDown={(e) => {
          if (e.key === "Enter" && onEnter) onEnter();
        }}
        {...props}
      />
      <button
        type="button"
        className="lg_eye"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Sembunyikan password" : "Lihat password"}
        title={visible ? "Sembunyikan password" : "Lihat password"}
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
};

const PopUpHeader = ({ title = "", onClose }) => (
  <div className="lg_popup_header">
    <p className="lg_popup_title">{title}</p>
    <img className="lg_close" src={CloseLogo} alt="tutup" onClick={onClose} />
  </div>
);

/* ------------------------------------------------------------------ */
/* Halaman                                                             */
/* ------------------------------------------------------------------ */

const Login = () => {
  const {
    username,
    setUsername,
    password,
    setPassword,
    handleLogin,
    popUpLogin,
    setPopUpLogin,
    popUpChangePassword,
    setPopUpChangePassword,
    ktpNumber,
    setKtpNumber,
    newPassword,
    setNewPassword,
    oldPassword,
    setOldPassword,
    handleKirimGantiPassword,
    handleSaveCatatan,
    setCatatan,
    popUpCatatan,
    setPopUpCatatan,
    catatan,
  } = useLogin();

  return (
    <div className="lg_root">
      {/* ===================== POP UP CATATAN ===================== */}
      {popUpCatatan && (
        <PopUpComponent>
          <PopUpHeader title="Catatan" onClose={() => setPopUpCatatan(false)} />
          <p className="lg_warning">
            Ini adalah catatan sementara, mohon di copy ke laporan operator jika
            ingin menulis laporan!
          </p>
          <textarea
            className="lg_textarea"
            value={catatan}
            onChange={(e) => setCatatan(e.target.value)}
          />
          <div className="lg_note_actions">
            <button
              className="lg_btn lg_btn_primary"
              onClick={() => handleSaveCatatan()}
            >
              Simpan
            </button>
            <button
              className="lg_btn lg_btn_outline"
              onClick={() => navigator.clipboard.writeText(catatan)}
            >
              Copy
            </button>
            <button
              className="lg_btn lg_btn_warn"
              onClick={() => setCatatan("")}
            >
              Hapus
            </button>
          </div>
        </PopUpComponent>
      )}

      {/* ===================== POP UP GANTI PASSWORD ===================== */}
      {popUpChangePassword && (
        <PopUpComponent>
          <PopUpHeader
            title="Ganti Password"
            onClose={() => setPopUpChangePassword(false)}
          />

          <div className="lg_field">
            <p className="lg_label">No.KTP (Cth: 3172010512370001)</p>
            <input
              className="lg_input lg_input_plain"
              type="number"
              placeholder="No.KTP"
              value={ktpNumber}
              onChange={(e) => setKtpNumber(e.target.value)}
              onWheel={(e) => e.target.blur()}
            />
          </div>

          <div className="lg_two_col">
            <div className="lg_field">
              <p className="lg_label">Password Lama</p>
              <PasswordInput
                placeholder="Password Lama"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </div>
            <div className="lg_field">
              <p className="lg_label">Password Baru</p>
              <PasswordInput
                placeholder="Password Baru"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="lg_popup_footer">
            <button
              className="lg_btn lg_btn_primary"
              onClick={() => handleKirimGantiPassword()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      )}

      {/* ===================== POP UP LOGIN GAGAL ===================== */}
      {popUpLogin && (
        <PopUpComponent>
          <p className="lg_popup_text">Username atau Password salah!</p>
          <div className="lg_popup_footer">
            <button
              className="lg_btn lg_btn_primary"
              onClick={() => setPopUpLogin(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      )}

      {/* ===================== KARTU LOGIN ===================== */}
      <div className="lg_card">
        <img className="lg_logo" src={LogoTim} alt="Logo-TIM" />
        <p className="lg_title">Login</p>
        <p className="lg_subtitle">Silakan masuk untuk melanjutkan</p>

        <div className="lg_form">
          <div className="lg_input_wrap">
            <span className="lg_input_icon">
              <UserIcon />
            </span>
            <input
              className="lg_input"
              type="text"
              placeholder="Username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleLogin();
                }
              }}
            />
          </div>

          <PasswordInput
            withIcon
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onEnter={handleLogin}
          />

          <button className="lg_btn_login" onClick={() => handleLogin()}>
            Masuk
          </button>
        </div>
      </div>

      <p className="lg_note_link" onClick={() => setPopUpCatatan(true)}>
        Catatan
      </p>
    </div>
  );
};

export default Login;
